<template>
  <svg
    :class="sizeClass"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
    />
  </svg>
</template>

<script>
import SizableMixin from "@/mixins/SizableMixin";
export default {
  mixins: [SizableMixin]
};
</script>
